import React from "react";
import { mailtoHref, mapsHref, smsHref, telHref } from "./contactLinks";
import "../mobile.css";

/**
 * Call / Text / Email / Map buttons for a contact or an address. A button only shows when its
 * value is usable (a phone number with at least 7 digits, one plain email address, a
 * non-empty address).
 */
export default function ContactActions({ phone, email, address, emailSubject = "", testId = "contact-actions" }) {
  const actions = [
    { key: "call", href: telHref(phone), icon: "fa-phone", label: "Call" },
    { key: "text", href: smsHref(phone), icon: "fa-comment", label: "Text" },
    { key: "email", href: mailtoHref(email, { subject: emailSubject }), icon: "fa-envelope", label: "Email" },
    { key: "map", href: mapsHref(address), icon: "fa-map-marker-alt", label: "Map", external: true },
  ].filter((a) => a.href);
  if (!actions.length) return null;
  return (
    <div className="jq-contact-actions" data-testid={testId}>
      {actions.map((a) => (
        <a
          key={a.key}
          href={a.href}
          className="btn btn-outline-primary"
          {...(a.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
        >
          <i className={`fas ${a.icon}`} aria-hidden="true" />
          <span>{a.label}</span>
        </a>
      ))}
    </div>
  );
}
